import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { OccupationEffects } from './occupation.effects';
import { STORE_TYPE } from './occupation.model';
import { occupationReducer } from './occupation.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(STORE_TYPE, occupationReducer),
    EffectsModule.forFeature([OccupationEffects]),
  ],
})
export class UIOccupationStoreModule {}
